import { render } from "./TitleSettings.vue?vue&type=template&id=206c478e"
import script from "./TitleSettings.vue?vue&type=script&lang=js"
export * from "./TitleSettings.vue?vue&type=script&lang=js"
script.render = render

export default script